(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["halloween-video-product"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const sections = document.querySelectorAll('.halloween-video-product');
    if (!('IntersectionObserver' in window)) return;

    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        const video = entry.target.querySelector('video');
        if (!video) return;
        if (entry.isIntersecting && !reduceMotion) {
          const playRequest = video.play();
          if (playRequest) playRequest.catch(() => {});
        } else {
          video.pause();
        }
      });
    }, { threshold: .28 });

    sections.forEach((section) => observer.observe(section));
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ourbella-campaign-banners"] && !Shopify.designMode) return;
  try {
    
  const initializeOurbellaCarousels = (scope = document) => {
    scope.querySelectorAll('[data-ob-carousel]').forEach((carousel) => {
      if (carousel.dataset.initialized === 'true') return;

      const slides = Array.from(carousel.querySelectorAll('[data-ob-slide]'));
      const dots = Array.from(carousel.querySelectorAll('[data-ob-dot]'));
      const previousButton = carousel.querySelector('[data-ob-prev]');
      const nextButton = carousel.querySelector('[data-ob-next]');
      const status = carousel.querySelector('[data-ob-status]');
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = carousel.dataset.autoplay === 'true' && !prefersReducedMotion;
      const delay = Number(carousel.dataset.delay) || 5000;
      let activeIndex = 0;
      let timer;
      let pointerStart = null;

      if (slides.length < 2) return;

      const showSlide = (newIndex, announce = true) => {
        activeIndex = (newIndex + slides.length) % slides.length;
        slides.forEach((slide, index) => {
          const active = index === activeIndex;
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
          if ('inert' in slide) slide.inert = !active;
        });
        dots.forEach((dot, index) => dot.setAttribute('aria-current', index === activeIndex ? 'true' : 'false'));
        if (announce && status) status.textContent = `Slide ${activeIndex + 1} of ${slides.length}`;
      };

      const stopAutoplay = () => window.clearInterval(timer);
      const startAutoplay = () => {
        stopAutoplay();
        if (autoplay) timer = window.setInterval(() => showSlide(activeIndex + 1, false), delay);
      };
      const navigate = (newIndex) => {
        showSlide(newIndex);
        startAutoplay();
      };

      previousButton?.addEventListener('click', () => navigate(activeIndex - 1));
      nextButton?.addEventListener('click', () => navigate(activeIndex + 1));
      dots.forEach((dot, index) => dot.addEventListener('click', () => navigate(index)));
      carousel.addEventListener('mouseenter', stopAutoplay);
      carousel.addEventListener('mouseleave', startAutoplay);
      carousel.addEventListener('focusin', stopAutoplay);
      carousel.addEventListener('focusout', startAutoplay);
      carousel.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') navigate(activeIndex - 1);
        if (event.key === 'ArrowRight') navigate(activeIndex + 1);
      });
      carousel.addEventListener('pointerdown', (event) => {
        if (event.pointerType !== 'mouse') pointerStart = event.clientX;
      });
      carousel.addEventListener('pointerup', (event) => {
        if (pointerStart === null) return;
        const distance = event.clientX - pointerStart;
        pointerStart = null;
        if (Math.abs(distance) < 45) return;
        navigate(activeIndex + (distance < 0 ? 1 : -1));
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) stopAutoplay();
        else startAutoplay();
      });

      carousel.dataset.initialized = 'true';
      showSlide(0, false);
      startAutoplay();
    });
  };

  initializeOurbellaCarousels();
  document.addEventListener('shopify:section:load', (event) => initializeOurbellaCarousels(event.target));
  document.addEventListener('shopify:block:select', (event) => {
    const slide = event.target.closest('[data-ob-slide]');
    const carousel = slide?.closest('[data-ob-carousel]');
    if (!slide || !carousel) return;
    const slides = Array.from(carousel.querySelectorAll('[data-ob-slide]'));
    slides.forEach((item, index) => item.setAttribute('aria-hidden', item === slide ? 'false' : 'true'));
    carousel.querySelectorAll('[data-ob-dot]').forEach((dot, index) => dot.setAttribute('aria-current', slides[index] === slide ? 'true' : 'false'));
  });

  } catch(e) { console.error(e); }
})();
})();
